import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CustomizedTable from "../../CustomizedTable/CustomizedTable";
import LoadIdCell from "../../CustomizedTable/CustomCells/OrderIdCell/LoadIdCell";
import DateTimeRangeCell from "../../CustomizedTable/CustomCells/DateTimeRangeCell/DateTimeRangeCell";
import MultiOptionsFilter from "../../CustomizedTable/Filters/MultipleOptionsFilter/MultipleOptionsFilter";
import SelectColumnFilter from "../../CustomizedTable/Filters/SelectColumnFilter/SelectColumnFilter";
import DateRangeFilter from "../../CustomizedTable/Filters/DateRangeFilter/DateRangeFilter";
import BrokerageStatusFilter from "../../CustomizedTable/Filters/BrokerageStatusFilter/BrokerageStatusFilter";
import BrokerageStatusCell from "../../CustomizedTable/CustomCells/BrokerageStatusCell/BrokerageStatusCell";
import { DefaultCell, TitleCaseCell, UpCaseCell } from "../../CustomizedTable/CustomCells/CustomCells";

export default function GlobalSearchOrderResults({
  searchResults,
  searchInput,
  handleTableAction
}) {
  const tableWidth = 1140;
  const orders = useMemo(() => searchResults, [searchResults]);

  const columns = useMemo(
    () => [
      {
        Header: "Load",
        accessor: "id",
        filter: "fuzzyText",
        width: 120,
        Cell: LoadIdCell,
      },
      {
        Header: "Status",
        accessor: "brokerageStatus",
        Filter: BrokerageStatusFilter,
        filter: "multi",
        width: 100,
        Cell: BrokerageStatusCell,
      },
      {
        Header: "Mode",
        accessor: "revenueCodeId",
        Filter: SelectColumnFilter,
        filter: "equal",
        width: 100,
        Cell: DefaultCell,
      },
      {
        Header: "Origin City",
        accessor: "originCity",
        filter: "fuzzyText",
        width: 130,
        Cell: TitleCaseCell,
      },
      {
        Header: "OS",
        accessor: "originState",
        Filter: MultiOptionsFilter,
        filter: "multi",
        width: 90,
        Cell: UpCaseCell,
      },
      {
        Header: "O-Arrival Window",
        accessor: "originArriveEarly",
        lateDate: "originArriveLate",
        stopType: "Origin",
        Filter: DateRangeFilter,
        filter: "dateBetween",
        width: 150,
        Cell: DateTimeRangeCell,
      },
      {
        Header: "Dest City",
        accessor: "destinationCity",
        filter: "fuzzyText",
        width: 130,
        Cell: TitleCaseCell,
      },
      {
        Header: "DS",
        accessor: "destinationState",
        Filter: MultiOptionsFilter,
        filter: "multi",
        width: 90,
        Cell: UpCaseCell,
      },
      {
        Header: "D-Arrival Window",
        accessor: "destinationArriveEarly",
        lateDate: "destinationArriveLate",
        stopType: "Destination",
        Filter: DateRangeFilter,
        filter: "dateBetween",
        width: 150,
        Cell: DateTimeRangeCell,
      },
    ]
  );

  return (
    <Box>
      <Box sx={{ margin: "20px 0", width: tableWidth }}>
        <Typography variant="h2" color="black_solid.80">
          {`${searchResults.length} Loads with ${searchInput} in the Order ID`}
        </Typography>
      </Box>
      <CustomizedTable
        id="global-search-order-results"
        columns={columns}
        data={orders}
        defaultHeight={300}
        defaultWidth={tableWidth}
        actionCallback={handleTableAction}
      />
    </Box>
  );
}

GlobalSearchOrderResults.propTypes = {
  searchResults: PropTypes.array.isRequired,
  searchInput: PropTypes.string.isRequired,
  handleTableAction: PropTypes.func
};